import { render, staticRenderFns } from "./induCompare.vue?vue&type=template&id=a37f85e6&scoped=true"
import script from "./induCompare.vue?vue&type=script&lang=js"
export * from "./induCompare.vue?vue&type=script&lang=js"
import style0 from "./induCompare.vue?vue&type=style&index=0&id=a37f85e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37f85e6",
  null
  
)

export default component.exports